var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"label":_vm.field.label,"append-icon":"mdi-paperclip","truncate-length":"50","prepend-icon":"","counter":"","multiple":"","show-size":"","filled":"","flat":"","dense":""},on:{"change":_vm.onFileSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }